export default class PasswordResetNotDoneError extends Error {}
